export const SELECT = "websites::select";
export const LOAD = "websites::load::request";
export const LOAD_COMPLETE = "websites::load::complete";
export const UPDATE_SECTION_ACTIVATION = "websites::section::activation";
export const UPDATE_SECTION = "websites::section::datas";
export const UPDATE_METAS = "websites::metas::update";
